// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1QnUL","clinicsSelect":"TableHeading_clinicsSelect__YIFS4"};